import React, { useMemo } from 'react';
import { useTracker } from '@/context/TrackerContext';
import { CouponWallTab } from '@/types/coupon-wall';
import Exposure from '@/components/exposure';
import { COUPON_WALL_BID_MC, COUPON_WALL_BID_MV } from '@/track/coupon-wall';

interface TabProps {
  tab: CouponWallTab;
  tabIndex: number;
  isActive: boolean;
  onClick: (planCode: string) => void;
  distributorChannel: number;
  useTwoRowCouponStyle: boolean; // 是否展示两行券样式
}

/**
 * 券墙Tab组件
 */
const Tab: React.FC<TabProps> = ({ tab, tabIndex, isActive, onClick, distributorChannel, useTwoRowCouponStyle }) => {
  const tracker = useTracker();
  // Tab埋点参数
  const tabValLab = useMemo(() => {
    return {
      tab_name: tab.tabName || '',
      tab_index: tabIndex,
      coupon_channel: distributorChannel,
      exposure_num: useTwoRowCouponStyle ? 1 : 0,
    };
  }, [tab.tabName, distributorChannel, tabIndex, useTwoRowCouponStyle]);

  // 处理Tab点击
  const handleClick = () => {
    // 上报点击埋点
    tracker?.moduleClick(COUPON_WALL_BID_MC.TAB, tabValLab);
    onClick(tab.planCode);
  };

  // 处理Tab曝光
  const handleExpose = () => {
    tracker?.moduleView(COUPON_WALL_BID_MV.TAB, tabValLab);
  }

  return (
    <Exposure onExpose={handleExpose}>
      <div
        className={`coupon-wall-tab ${isActive ? 'active' : ''}`}
        onClick={handleClick}
      >
        <div className="coupon-wall-tab-content">
          {tab.tabIcon && (
            <img 
              className="coupon-wall-tab-icon" 
              src={tab.tabIcon} 
              alt={tab.tabIcon} 
            />
          )}
          <span className="coupon-wall-tab-title">{tab.tabName}</span>
        </div>
      </div>
    </Exposure>
  );
};

export default Tab;
